export const PROFILER_FINANCIAL_STATEMENTS = {
  EBIT: {
    xbrl_code: 3109, // should become array of codes probably
    name: 'EBIT'
  },
  EBT: {
    xbrl_code: 7272, // should become array of codes probably
    name: 'EBT'
  },
  numberOfEmployees: {
    xbrl_codes: ['nt.employees', 'sd.employees'], // should become array of codes probably
    name: 'Number of employees'
  }
};

// Stable metric identities exposed by the backend (TD-2401). The `metric_group`
// field collapses reported + self-disclosed revenue/employees into one series
// (self-disclosed and reported points share it); every other row carries its
// own xbrl_code as the metric_group. The frontend groups and formats on these
// instead of raw xbrl_codes so the profiler no longer decodes accounting-method
// specifics (TC vs COGS) or self-disclosed codes.
export const METRIC_GROUP = {
  REVENUE: 'td.revenue',
  EMPLOYEES: 'td.employees'
};

// Reported revenue codes, kept only for the deploy window: until TD-2401 ships on
// an environment the BE sends no metric_group, so the mapper falls back to the
// row's own xbrl_code and a revenue item is identified by these instead. Drop
// this once metric_group is live everywhere.
const LEGACY_REVENUE_CODES = [
  'is.netIncome.regular.operatingTC.grossTradingProfit.totalOutput.netSales',
  'is.netIncome.regular.operatingCOGS.grossOpProfit.netSales'
];

const REVENUE_METRICS = Object.freeze(new Set([METRIC_GROUP.REVENUE, ...LEGACY_REVENUE_CODES]));

/**
 * Whether a mapped financial item is the revenue series, on either side of the
 * TD-2401 backend rollout. Post-rollout `metric_group` is `td.revenue` (which
 * also covers COGS-basis and self-disclosed revenue); pre-rollout it falls back
 * to the raw reported xbrl_code.
 * @param {Object} item mapped financial item (not a per-year entry)
 * @returns {boolean}
 */
export const isRevenueMetric = (item) => REVENUE_METRICS.has(item?.metric_group);
